var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ loading: _vm.loading },on:{"click":_vm.onClick}},[_c('LoadingIcon',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}]}),_vm._t("default",[_vm._v("Button")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }